import { IconNames } from 'components/Icon';

export const GalleryTypes = {
  Blog: IconNames.Wifi,
  News: IconNames.Newspaper,
  Newsletter: IconNames.Newspaper,
  Podcast: IconNames.HeadPhones,
};
